import { useMutation } from "@apollo/client/react";
import { CONFIRMAR_EQUIPO } from "../../../data/graphQL/mutations/ResumenIngresoValidation/AddConfirmarEquipo";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { VALIDATE_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ValidateRI";
import { VALIDATE_CONTRATO } from "../../../data/graphQL/mutations/Contratos/validateContrato";
import { CAMBIAR_PROGRAMA_EVALUACION } from "../../../data/graphQL/mutations/ResumenIngresoValidation/CambiarProgramaEvaluacion";

export const useGetActions = ({ handleChange, notification }) => {
  const navigate = useNavigate();

  const [validateContrato] = useMutation(VALIDATE_CONTRATO, { variables: { idEvaluacion: notification?.idEvaluacion } });

  const [validarRI, { loading: validateLoading }] = useMutation(VALIDATE_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success("Se ejecutó la validación correctamente!");
    }
  });

  const [confirmarEquipo, { loading: confirmarEquipoLoading }] = useMutation(CONFIRMAR_EQUIPO, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      toast.success('Se confirmó el equipo correctamente!');
    }
  });

  const [cambiarPrograma, { loading: cambiarProgramaLoading }] = useMutation(CAMBIAR_PROGRAMA_EVALUACION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data?.cambiarProgramaContrato?.success)
      toast.success('Se cambió el programa correctamente!');
    }
  });

  const handleClickValidar = (rechazo) => {
    validarRI({
      variables: {
        input: {
          idEvaluacion: notification?.idEvaluacion,
          idMotivoRechazo: rechazo?.idMotivoRechazo,
          observacion: rechazo?.observacion,
          tipoNotificacion: "CONFIRMAR_EQUIPO",
          requiereIndicacion: false
        }
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);

      if (rechazo?.idMotivoRechazo)
      validateContrato();

    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  const handleClickArmarEquipo = (equipo, thenCallback) => {
    confirmarEquipo({
      variables: {
        idEvaluacion: notification?.idEvaluacion,
        addConfirmarEquipoItems: equipo.map((item) => ({
          idProfesional: item.idProfesional,
          idFiguraProfesional: item.idTipoProfesional,
          idFrecuenciaProfesional: item.idFrecuencia
        }))
      }
    }).then(() => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 500);
      thenCallback();
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  const handleClickCambiarPrograma = () => {
    cambiarPrograma({
      variables: {
        idEvaluacion: notification?.idEvaluacion,
        tipoNotificacionAsistencial: "CONFIRMAR_EQUIPO"
      }
    }).then((res) => {
      if (!res?.data?.cambiarProgramaContrato?.success)
      return toast.error(res?.data?.cambiarProgramaContrato?.error || 'Ha ocurrido un error not success!');

      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  return {
    handleClickValidar,
    handleClickArmarEquipo,
    handleClickCambiarPrograma,
    loading: confirmarEquipoLoading || validateLoading || cambiarProgramaLoading
  };
};